export enum DssTemaEnum {
    DARK = "dark",
    LIGHT = "light"
}

